
// https://www.geradorcpf.com/javascript-validar-cpf.htm
export const isValidCpf = (cpf: string) => {
  cpf = cpf.replace(/[^\d]+/g,'');
  let add: number, rev: number, i: number;	
	if(cpf === '') return false;	
	// Elimina CPFs invalidos conhecidos	
	if (cpf.length !== 11 || 
		cpf === "00000000000" || 
		cpf === "11111111111" || 
		cpf === "22222222222" || 
		cpf === "33333333333" || 
		cpf === "44444444444" || 
		cpf === "55555555555" || 
		cpf === "66666666666" || 
		cpf === "77777777777" || 
		cpf === "88888888888" || 
		cpf === "99999999999")
			return false;		
	// Valida 1o digito	
	add = 0;	
	for (i=0; i < 9; i ++)		
		add += parseInt(cpf.charAt(i)) * (10 - i);	
		rev = 11 - (add % 11);	
		if (rev === 10 || rev === 11)		
			rev = 0;	
		if (rev !== parseInt(cpf.charAt(9)))		
			return false;		
	// Valida 2o digito	
	add = 0;	
	for (i = 0; i < 10; i ++)		
		add += parseInt(cpf.charAt(i)) * (11 - i);	
	rev = 11 - (add % 11);	
	if (rev === 10 || rev === 11)	
		rev = 0;	
	if (rev !== parseInt(cpf.charAt(10)))
		return false;		
	return true;   
}

// https://www.geradorcnpj.com/javascript-validar-cnpj.htm
export const isValidCnpj = (cnpj: string) => {
  // Remove non-digit characters
  cnpj = cnpj.replace(/[^\d]+/g, '');

  let tamanho: number, numeros: any, digitos: any, soma: number, pos: number, i: number, resultado: number;

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  const knownInvalidCnpjs = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ];
  
  if (knownInvalidCnpjs.includes(cnpj)) return false;

  // Valida DVs
  tamanho = cnpj.length - 2;
  numeros = cnpj.substring(0, tamanho);
  digitos = cnpj.substring(tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0), 10)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i), 10) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(1), 10)) return false;

  return true;
};


export const isValidEmail = (email: string) => {
  const re = /(?:[a-z0-9.!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
  
  return re.test(String(email).toLowerCase());
}

export const linkify = (mdtext: string) => {
  /**
   * Convert a string with Markdown link elements, e.g: [Eventials Website](https://eventials.com)
   * to a list with string and React <a href> components. 
   */
  let stringsOrComponents: React.ReactNode[] = [];
  let index = 0;

  const REGEX_MARKDOWN_LINK = /(\[(.*?)\]\((.*?)\))+/g;

  let match = REGEX_MARKDOWN_LINK.exec(mdtext);

  if (match === null) return [mdtext]; 

  do {
      stringsOrComponents.push(mdtext.substring(index, match.index));
      index += match.index + match[0].length;

      const label = match[2];
      const link = match[3];

      stringsOrComponents.push(<a href={link} className="red" target="_blank" rel="noreferrer">{label}</a>);

  } while ((match = REGEX_MARKDOWN_LINK.exec(mdtext)) !== null)

  if(index < mdtext.length) {
      stringsOrComponents.push(mdtext.substring(index, mdtext.length -1));
  }

  return stringsOrComponents;
}

export const formatTicketValue = (value: number) => {
  const splited = value.toString().split(".");
  if(splited.length <= 1) return `R$ ${value},00`;
  if(splited[1].split("").length > 0) return `R$ ${splited[0]},${splited[1]}`;
  return `R$ ${splited[0]},${splited[1]}0`;
}

export const formatHour = (data?: string) => {
  if(!data) return "";
  
  const hourMin = data.toString().split(".");
  const hour = hourMin[0];
  const min = hourMin[1] ? (
    hourMin[1].length > 1 ? hourMin[1] : hourMin[1]+"0"
  ) : "00";

  return `${hour}h${min}`;
}

export const getSecondsFromString = (str: string) => {
  var ret = 0;
  var seconds = str.match(/(\d+)\s*s/);
  var days = str.match(/(\d+)\s*d/);
  var hours = str.match(/(\d+)\s*h/);
  var minutes = str.match(/(\d+)\s*m/);
  if (days) { ret += parseInt(days[1], 10) * 86400; }
  if (hours) { ret += parseInt(hours[1], 10) * 3600; }
  if (minutes) { ret += parseInt(minutes[1], 10) * 60; }
  if (seconds) { ret += parseInt(seconds[1], 10); }
  return ret;
}

/**
 * Format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx 
 * Generates a GUID (Globally Unique Identifier) with a combination of random hexadecimal digits.
*/
export const guid = () => {
  const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/**
 * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 * Generates a UUID (Universally Unique Identifier) following the RFC4122 standard.
 */
export const uuid = () => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid = [];

  // rfc4122 requires these characters
  uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
  uuid[14] = '4';

  // Fill in random data.  At i==19 set the high bits of clock sequence as
  // per rfc4122, sec. 4.1.5
  for (let i = 0; i < 36; i++) {
    if (!uuid[i]) {
      const r = 0 | Math.random() * 16;
      uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
    }
  }

  return uuid.join('');
}

export const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};
